import { getFeaturedWorksThumbnails } from "api/storageManager";
import { AboutContainer, HomeContainer, RoomListContainer } from "views";
import { setFeaturedWorkThumbnails } from "module/reducers/featuredWorksImageReducer";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "sass/index.scss";
import GamePage from "views/GamePage";
import { SocketProvider } from "context/SocketContext";
import SingleRoleRouletteView from "views/singleRoleRoulette/SingleRoleRouletteView";
import TeamBuilderView from "views/teamBuilder/TeamBuilderView";
import LuckyDrawView from "views/luckyDraw/LuckyDrawView";
import FightSimulatorView from "views/fightSimulator/FightSimulatorView";
import { products } from "module/products";
import { HelmetProvider } from "react-helmet-async";
import LanguageInitializer from "./components/LanguageInitializer";

function App() {
  const dispatch = useDispatch();

  function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  useEffect(() => {
    setScreenSize();
    window.addEventListener("resize", setScreenSize);

    const fetchThumbnails = async () => {
      try {
        const thumbnails = await getFeaturedWorksThumbnails();
        dispatch(setFeaturedWorkThumbnails(thumbnails));
      } catch (error) {
        console.error("Error fetching Thumbnails", error);
      }
    };
    fetchThumbnails();
  }, [dispatch]);

  return (
    <HelmetProvider>
      <LanguageInitializer>
        <SocketProvider>
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <Routes>
              <Route path="/" element={<HomeContainer />} />
              <Route path="/about" element={<AboutContainer />} />
              <Route path="/room" element={<RoomListContainer />} />
              <Route path="/game" element={<GamePage />} />
              <Route
                path="/single-role-roulette"
                element={<SingleRoleRouletteView product={products[5]} />}
              />
              <Route
                path="/team-builder"
                element={<TeamBuilderView product={products[6]} />}
              />
              <Route
                path="/lucky-draw"
                element={<LuckyDrawView product={products[7]} />}
              />
              <Route
                path="/fight-simulator"
                element={<FightSimulatorView product={products[8]} />}
              />
              {/* <Route path="/jorney2h" element={<JorneyToHomeContainer />} /> */}
            </Routes>
          </div>
        </SocketProvider>
      </LanguageInitializer>
    </HelmetProvider>
  );
}

export default App;
